import { render, staticRenderFns } from "./ProcessCommunication.vue?vue&type=template&id=36bd4f16&scoped=true"
import script from "./ProcessCommunication.vue?vue&type=script&lang=js"
export * from "./ProcessCommunication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bd4f16",
  null
  
)

export default component.exports